import select from 'dom-select'
import {
  set
} from 'utils/general'

function generateStyleEle (dataset) {
  const { height, mobileHeight, unit, id } = dataset
  var style = `
    #${id} {
      padding-bottom: ${height}${unit};
    }{{MOBILESTYLE}}
  `
  var mobileStyleEle = ''

  if (height !== mobileHeight) {
    mobileStyleEle = `
      @media screen and (max-width: 767px) {
        #${id} {
          padding-bottom: ${mobileHeight}${unit};
        }
      }
    `
  }

  return style.replace('{{MOBILESTYLE}}', mobileStyleEle)
}

export default el => {
  const { dataset } = el
  const { height, mobileHeight, unit } = dataset
  const css = generateStyleEle(dataset)
  const style = document.createElement('style')
  select('head').appendChild(style)

  style.type = 'text/css'

  if (style.styleSheet) {
    style.styleSheet.cssText = css
  } else {
    style.appendChild(document.createTextNode(css))
  }
}
